	Object.defineProperty(exports, "__esModule", {
	    value: true
	});exports.default=window.GrimoireJS.lib.fundamental.Asset.TextFileResolver;


//////////////////
// WEBPACK FOOTER
// ./~/grimoirejs-fundamental/ref/Asset/TextFileResolver.js
// module id = 18
// module chunks = 0